import { AudioContext } from "standardized-audio-context";

const useAudioContext = () => {
  const audioContext = useRef(new AudioContext());
  return audioContext;
};

export default useAudioContext;
